var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[(_vm.popoverData.isPopover)?_c('div',{staticClass:"section__popover"},[_c('PopupComponent',{attrs:{"title":_vm.popoverData.title,"content":_vm.popoverData.content,"target":_vm.popoverData.target}})],1):_vm._e(),_c('div',{staticClass:"section__title"},[_c('label',{class:{
        'color-secondary-title': _vm.colorSecondaryTitle,
      }},[_vm._v(" "+_vm._s(_vm.title)),(_vm.mandatory)?_c('span',{staticClass:"section__mandatory"},[_vm._v("*")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }